/**
 * Sprint 76 — Copiar al portapapeles, con la red de seguridad puesta.
 *
 * Todo el flujo a domicilio termina en un mensaje que alguien pega en WhatsApp Web. Si el botón
 * "copiar" falla en silencio, el operador pega lo que tenía antes en el portapapeles —o nada— y
 * se entera cuando el cliente contesta "¿qué me mandaste?". Por eso esto devuelve si funcionó, y
 * quien lo llama tiene que decirlo en pantalla.
 *
 * `navigator.clipboard` necesita contexto seguro y foco en el documento; en Electron los hay,
 * pero en el track web servido por http (o con la ventana en segundo plano) puede rebotar. El
 * respaldo con `execCommand` es viejo y está deprecado, y por eso mismo funciona en todos lados.
 */
export async function copiarAlPortapapeles(texto: string): Promise<boolean> {
  if (!texto) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch {
    // Cae al respaldo: no hay nada que reportar todavía.
  }

  try {
    const area = document.createElement('textarea');
    area.value = texto;
    // Fuera de la vista pero dentro del documento: `select()` no funciona sobre un nodo suelto.
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}
